import { Box, InputLabel, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CommonUtil from '../util/CommonUtils';
import { InfoOutlined } from '@mui/icons-material';

export default function CustomInput({ sx = {}, ...props }) {
  const [helperText, setHelperText] = useState(props.helperText);
  const [error, setError] = useState(props.error);
  const { t } = useTranslation();

  useEffect(() => {
    setError(props.error);
    setHelperText(props.helperText);
  }, [props.error, props.helperText]);

  const handleChange = (e) => {
    let val = e.target.value;
    if (val.trim() === '') {
      val = val.trim();
    }
    if (e.target.value.length > 0 && val.length === 0) {
      return;
    }
    if (val.length > 2) {
      if (val[val.length - 1] === ' ' && val[val.length - 2] === ' ') {
        return;
      }
      if (val[0] === ' ') {
        return;
      }
    }
    if (props.regex === 'none' && props.validation) {
      switch (props.validation) {
        case 'alpha-numeric':
          handleAlphaNumeric(e);
          break;
        case 'numeric':
          handleNumeric(e);
          break;
        case 'email':
          handleEmail(e);
          break;
        case 'password':
          handlePassword(e);
          break;
        case 'code':
          handleCode(e);
          break;
        case 'mobile':
          handleMobile(e);
          break;
        case 'postcode':
          handlePostCode(e);
          break;
        case 'alpha-numeric-underscore':
          handleCodeUnderscore(e);
          break;
        case 'alpha-numeric-space':
          handleAlphaNumericSpace(e);
          break;
        case 'numericWithoutDot':
          handleNumericWithoutDot(e);
          break;
        default:
          props.handleChange(e);
      }
    }
  };

  const handleAlphaNumeric = (e) => {
    if (CommonUtil.isAlphaNumeric(e.target.value)) {
      props.handleChange(e);
      setHelperText(props.helperText);
      setError(false);
    } else {
      setError(true);
      setHelperText(t('Only accepts alphanumeric values'));
    }
  };

  const handleCodeUnderscore = (e) => {
    if (CommonUtil.isAlphaNumericUnderscore(e.target.value)) {
      props.handleChange(e);
      setHelperText(props.helperText);
      setError(false);
    } else {
      setError(true);
      setHelperText(t('Only accepts alphabets, numerics and underscore'));
    }
  };

  const handleAlphaNumericSpace = (e) => {
    if (CommonUtil.isAlphaNumericSpace(e.target.value)) {
      props.handleChange(e);
      setHelperText(props.helperText);
      setError(false);
    } else {
      setError(true);
      setHelperText(t('Only accepts alphabets, numerics , space and underscore'));
    }
  };
  const handleNumericWithoutDot = (e) => {
    if (CommonUtil.isValidPasitiveNumeric(e.target.value)) {
      props.handleChange(e);
      setHelperText(props.helperText);
      setError(false);
    } else {
      setError(true);
      setHelperText('Only accepts numerics');
    }
  };

  const handleCode = (e) => {
    if (CommonUtil.isAlphaNumeric(e.target.value)) {
      props.handleChange(e);
      setHelperText(props.helperText);
      setError(false);
    } else {
      setError(true);
      setHelperText(t('LVL0004'));
    }
  };

  const handlePostCode = (e) => {
    if (CommonUtil.isValidCode(e.target.value)) {
      props.handleChange(e);
      setHelperText(props.helperText);
      setError(false);
    } else {
      setError(true);
      setHelperText(t('LVL0002'));
    }
  };

  const handleNumeric = (e) => {
    if (CommonUtil.isValidNumeric(e.target.value)) {
      props.handleChange(e);
      setHelperText(props.helperText);
      setError(false);
    } else {
      setError(true);
      setHelperText(t('Please enter valid input'));
    }
  };

  const handleEmail = (e) => {
    props.handleChange(e);
    if (CommonUtil.isValidEmail(e.target.value)) {
      setHelperText(props.helperText);
      setError(false);
    } else {
      setError(true);
      setHelperText(t('LVL0003'));
    }
  };
  const handleMobile = (e) => {
    if (CommonUtil.isValidPasitiveNumeric(e.target.value)) {
      props.handleChange(e);
      setHelperText(props.helperText);
      setError(false);
    } else {
      setError(true);
      setHelperText(t('LVL0005'));
    }
  };

  const handlePassword = (e) => {
    props.handleChange(e);
    if (CommonUtil.isValidPassword(e.target.value)) {
      setHelperText(props.helperText);
      setError(false);
    } else {
      setError(true);
      setHelperText(t('Enter valid password'));
    }
  };

  const handleFocus = (event) => {
    event.target.removeAttribute('readonly');
  };

  return (
    <Box letiant='standard' sx={{ width: '100%', pt: '15px', "@media (max-width: 1200px)": { pt: '0px', } }}>
      <InputLabel
        shrink
        htmlFor="bootstrap-input"
        style={{ paddingLeft: "0px", size: "large", alignContent: "center" }}
      >
        <Box display={"flex"} alignItems={"center"}>
          <Typography variant="fieldLabel">
            {" "}
            {props.label}{" "}
          </Typography>
          {props.required ? (
            <span
              style={{ color: "red", display: "flex", paddingLeft: "5px" }}
            >
              *
            </span>
          ) : (
            ""
          )}
          {props.info && (
            <span
              style={{
                paddingLeft: "5px",
                cursor: "pointer",
                display: "flex",
              }}
            >
              <Tooltip title={props.info} placement="right" arrow>
                <InfoOutlined style={{ paddingBottom: "-5px" }} />
              </Tooltip>
            </span>
          )}
        </Box>
      </InputLabel>
      <TextField
        {...props}
        fullWidth
        placeholder={props.placeholder}
        className='helper-text'
        label={""}
        value={props.value}
        type={props?.type}
        helperText={helperText}
        error={error}
        onChange={(e) => handleChange(e)}
        InputProps={{
          autoComplete: 'off',
          readOnly: true,
          onFocus: handleFocus,
        }}
        sx={{
          fontSize: '16px',
          fontFamily: 'inter',
          '& .MuiOutlinedInput-input.MuiInputBase-inputSizeSmall': {
            padding: '11px'
          },
          "& .MuiOutlinedInput-input": {
            backgroundColor: "#fff !important",
          },
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#fff important",
          },
          ...sx
        }}
      />
    </Box>
  );
}

CustomInput.defaultProps = {
  validation: 'none',
  regex: 'none',
};
